import moment from 'moment';

const dateMoment = (val = null) =>
  val ? moment.utc(val).utcOffset('+05:30') : moment.utc().utcOffset('+05:30');

const dateMomentWithFormatting = (val = null, formatting) =>
  val && formatting ? moment.utc(val, formatting).utcOffset('+05:30') : '';

export const getFormattedDate = (val = null, format = 'DD-MM-YYYY') =>
  dateMoment(val).format(format);

export const getDateFromFormat = (val = null, format = '') =>
  dateMoment(val, format);

export const getDateMomentSuggestedFormat = (val = null, format = '') =>
  val && format ? moment.utc(val, format).utcOffset('+05:30') : null;

export const getTimeStamp = (val = null) => dateMoment(val).valueOf();

export const getTimeStampFromDate = (val = null) =>
  getDateMomentSuggestedFormat(val, 'DD-MM-YYYY HH:mm:ss').valueOf();

export const getMoment = (val = null) => dateMoment(val);

export const getValueOff = (val = null) =>
  val && dateMoment(val) && dateMoment(val).valueOf()
    ? dateMoment(val).valueOf()
    : null;

export const getToday = (format = 'DD-MM-YYYY') =>
  dateMoment(null).format(format);

export const getTodayInDayFormat = () =>
  dateMoment(null).format('ddd').toUpperCase();

export const getHTMLDateObject = (val = null) =>
  val &&
  moment.utc(val).utcOffset('+05:30') &&
  moment.utc(val).utcOffset('+05:30').toDate()
    ? moment.utc(val).utcOffset('+05:30').toDate()
    : null;

const getDataFromTimePickerStringMain = (value, substitutVal = '12:0:am') => {
  const val = !value || (value && value.trim() === '') ? substitutVal : value;
  const [hours, mins, am] = val.split(':');

  return {
    hours,
    mins,
    am,
  };
};

export const getSetTimeToMoment = (val, time = '12:0') => {
  const timeSplit = time.split(':');

  const result = dateMoment(val).set({
    hours: timeSplit[0],
    minutes: timeSplit[1],
  });

  return result;
};

export const getMilitaryTimeFromTimePickerString = (val = '12:0:am') => {
  const input = `2016-12-08 ${val} +05:30`;
  const result = dateMomentWithFormatting(input, 'YYYY-MM-DD h:m:a ZZ').format(
    'H:m'
  );

  return result;
};

export const getDataFromTimePickerString = getDataFromTimePickerStringMain;

export const formatStringTimeStampDateToUpdatedAt = (date = '') =>
  date ? getFormattedDate(Number(date), 'DD/MM/YYYY h:mm:ss A') : '';

export const getMomentFromCurruntTime = () => {
  return moment.utc().utcOffset('+05:30');
};

export const getDateFromMoment = (moment) => {
  return moment.utc().utcOffset('+05:30').toDate();
};

export const getMomentFromDate = (date) => {
  return moment(date);
};

export const getTimeAGoFromDate = (date) => {
  return moment(date).fromNow();
};

export const getTimeAGoFromDateTimeStamp = (date = '') => {
  return date ? getTimeAGoFromDate(Number(date)) : '';
};
